import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goToSection = (id) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 350);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToPage = (path) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-cream-100/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
    }`}>
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <button
          onClick={() => goToPage('/')}
          data-testid="header-logo"
          className={`text-2xl tracking-wider transition-colors ${
            isScrolled ? 'text-charcoal' : 'text-white'
          }`}
        >
          FLY OUT <span className="font-serif font-normal italic">by Samantha</span>
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          <button 
            onClick={() => goToSection('afronation-2027')} 
            data-testid="nav-2027"
            className={`font-medium transition-colors ${
              isScrolled ? 'text-gold-600 hover:text-gold-500' : 'text-gold-200 hover:text-gold-100'
            }`}
          >
            Cap-Vert 2027
          </button>
          <button 
            onClick={() => goToPage('/voyage-effectue')} 
            data-testid="nav-2026"
            className={`font-light transition-colors ${
              isScrolled ? 'text-charcoal hover:text-gold-500' : 'text-white hover:text-gold-200'
            }`}
          >
            Voyage effectué
          </button>
          <Button 
            onClick={() => goToSection('contact')}
            data-testid="nav-contact"
            className="bg-gold-400 hover:bg-gold-500 text-charcoal rounded-full px-6 transition-all duration-300 hover:scale-105"
          >
            Contact
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`md:hidden ${
            isScrolled ? 'text-charcoal' : 'text-white'
          }`}
          data-testid="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-cream-100 border-t border-sand-100 shadow-lg">
          <div className="px-6 py-4 space-y-4">
            <button 
              onClick={() => goToSection('afronation-2027')} 
              className="block w-full text-left text-gold-600 hover:text-gold-500 font-medium"
            >
              Cap-Vert 2027
            </button>
            <button 
              onClick={() => goToPage('/voyage-effectue')} 
              className="block w-full text-left text-charcoal hover:text-gold-500 font-light"
            >
              Voyage effectué
            </button>
            <Button 
              onClick={() => goToSection('contact')}
              className="w-full bg-gold-400 hover:bg-gold-500 text-charcoal rounded-full"
            >
              Contact
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
